module.exports = function getResource(label, vars = []) {
    let resources = {
        biTermsAndConditions: 'Modalités du programme Beauty Insider',
        termsAndConditions: 'Modalités et conditions',
        required: '(requis)'
    };

    return resources[label];
};
